import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { getLenis } from '@/lib/lenis';

gsap.registerPlugin(ScrollToPlugin);

export function scrollToId(id, { behavior = 'smooth' } = {}) {
    const el = id ? document.getElementById(id) : null;
    const nav = document.getElementById('site-navbar');
    const offset = (nav?.getBoundingClientRect().height || 80) + 16;

    const top = (!id || !el) ? 0 : el.getBoundingClientRect().top + window.scrollY - offset;

    const lenis = getLenis();
    if (lenis) {
        lenis.scrollTo(top, {
            immediate: behavior === 'auto' || behavior === 'instant',
            lerp: 0.08,
        });
        return;
    }

    if (behavior === 'auto' || behavior === 'instant') {
        window.scrollTo({ top, behavior: 'auto' });
        return;
    }

    const distance = Math.abs(window.scrollY - top);
    const duration = Math.min(1.4, Math.max(0.5, distance / 1200));

    gsap.to(window, {
        duration,
        scrollTo: { y: top },
        ease: 'power3.inOut',
        overwrite: 'auto',
    });
}

export function waitForIdAndScroll(id, { attempts = 30, interval = 100, behavior = 'smooth' } = {}) {
    if (!id) {
        scrollToId(null, { behavior });
        return;
    }

    let tries = 0;
    const tick = () => {
        if (document.getElementById(id)) {
            scrollToId(id, { behavior });
            return;
        }
        tries += 1;
        if (tries < attempts) setTimeout(tick, interval);
    };
    tick();
}
